export function withDebounce<T extends unknown[]>(func: (...args: T) => void, timeout = 500) {
  let timer: NodeJS.Timeout;
  return (...args: T) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func(...args);
    }, timeout);
  };
}
